module.exports = ".card.center-card {\n  display: inline-block;\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  width: 21%; }\n\n@media (max-width: 767px) {\n  .card.center-card {\n    display: inline-block;\n    position: absolute;\n    left: 10%;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n    width: 78%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/candidate/changepassword/changepassword.component.scss
// module id = ./src/app/candidate/changepassword/changepassword.component.scss
// module chunks = main